import {match} from 'ts-pattern';

import type {DataGridRow} from '@dms/api/core';

import {
  DATA_GRID_ENTITY_VALUE_SCHEMA,
  DATA_GRID_STRING_ARRAY_VALUE_SCHEMA,
  readDataGridCell,
} from './readDataGridCell';

export function readDataGridCellEntityLabel(row: DataGridRow, keys: readonly string[]) {
  const cellValue = readDataGridCell(row, keys);
  const entityResult = DATA_GRID_ENTITY_VALUE_SCHEMA.safeParse(cellValue);

  return match(entityResult)
    .with({success: true}, ({data}) => data.label)
    .with({success: false}, () => {
      const arrayResult = DATA_GRID_STRING_ARRAY_VALUE_SCHEMA.safeParse(cellValue);

      return match(arrayResult)
        .with({success: true}, ({data}) => data[0])
        .with({success: false}, () => undefined)
        .exhaustive();
    })
    .exhaustive();
}
